import React from "react";
import "animate.css";
import "./IndustrialAR.css";



function IndustrialAR() {
  return (
    <>
      {/* Hero Section */}
      <div className="container-fluid bg-breadcrumb14">
        <div className="bg-breadcrumb-single"></div>

        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Industrial AR Solutions
          </h4>

          <p
            className="text-white wow fadeInUp"
            data-wow-delay="0.2s"
            style={{
              maxWidth: "700px",
              margin: "0 auto",
              fontSize: "18px",
            }}
          >
            {/* Revolutionizing industrial maintenance through
            hands-free augmented reality, real-time overlays,
            and remote expert collaboration. */}
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container py-5">

        {/* Intro Section */}
        <section className="mb-5">
          <div className="row align-items-center">

            <div
              className="col-lg-6 wow fadeInLeft"
              data-wow-delay="0.2s"
            >
              <span className="text-primary fw-semibold">
                Smart Maintenance Technology
              </span>

              <h2 style={{ color: "#021bf5" }} className="fw-bold mb-4">
                Cooling Under Control:
                <br />
                Industrial AR for Data Center Maintenance
              </h2>

              <p style={{ color: "black" }} className=" mb-4">
                As modern data centers continue to scale in complexity, maintaining optimal cooling performance has
                become critical to ensuring operational efficiency, energy savings, and infrastructure reliability.
                Traditional maintenance approaches often rely on manual inspections, disconnected monitoring tools,
                and reactive troubleshooting, resulting in increased operational costs
                and potential downtime.
              </p>
              <p style={{ color: "black" }}>Celersoft's Industrial Augmented Reality (AR) solutions are transforming data center maintenance by
                combining real-time asset intelligence, predictive analytics, and immersive technician support into a
                single digital workflow. By enabling technicians to visualize equipment data directly within the
                physical environment, Industrial AR helps organizations
                improve cooling system performance, reduce maintenance complexity, and accelerate issue resolution.</p>


            </div>

            <div
              className="col-lg-6 text-center wow fadeInRight"
              data-wow-delay="0.3s"
            >
              <img
                src="assets/img/Industrial_AR.jpg"
                alt="Industrial AR"
                className="img-fluid"
                style={{
                  maxHeight: "480px",
                  width: 600,
                  height: 800,
                  objectFit: "cover",

                  borderradius: 24,
                  filter:
                    "drop-shadow(0px 15px 30px rgba(0,0,0,0.2))",
                }}
              />
            </div>

          </div>
        </section>


        <section className="ar-ecosystem-section py-5">

          <div className="container">

            <div className="text-center mb-5">
              <h2 className="fw-bold">
                Operational Efficiency & Cost Savings
              </h2>

              <p className="mx-auto" style={{ maxWidth: "900px" }}>
                Industrial AR empowers data center teams with real-time visibility into critical cooling infrastructure.
              </p>
            </div>

            <div className="ar-ecosystem-wrapper">

              {/* TOP */}

              <div className="ar-card card-top">

                <h4>10–20%</h4>

                <h5>
                  Reduction in Cooling Energy Costs
                </h5>

                <p>
                  Identify airflow inefficiencies,
                  thermal hotspots and cooling
                  performance anomalies before
                  they impact operations.
                </p>

              </div>

              {/* LEFT */}

              <div className="ar-card card-left-top">

                <h5>
                  Real-Time Equipment Data Overlays
                </h5>

                <p>
                  Technicians access operating parameters,
                  maintenance history, diagnostics,
                  performance metrics and system status
                  directly within their field of view.
                </p>

              </div>

              <div className="ar-card card-left-bottom">

                <h5>
                  Predictive Maintenance Alerts
                </h5>

                <p>
                  Detect equipment degradation and operational abnormalities before failures occur, reducing downtime and extending asset lifespan.
                </p>

              </div>

              {/* CENTER IMAGE */}

              <div className="ar-center-image">

                <img
                  src="/assets/img/IndustrialAR4.png"
                  alt="Industrial AR"
                />

              </div>

              {/* RIGHT */}

              <div className="ar-card card-right-top">

                <h5>
                  Live Remote Expert Collaboration
                </h5>

                <p>
                  Connect technicians instantly with remote specialists for guided troubleshooting, reducing response times and accelerating issue resolution.
                </p>

              </div>

              <div className="ar-card card-right-bottom">

                <h5>
                  Accelerated Technical Training
                </h5>

                <p>
                  AR-enabled workflows create immersive learning experiences that improve onboarding, technical readiness, and knowledge retention.
                </p>

              </div>
              {/* BOTTOM */}

              <div className="ar-card card-bottom">

                <h5>
                  Hands-Free Safety in High-Voltage Areas
                </h5>

                <p>
                  Wearable AR devices provide critical information while keeping technicians focused on safe operations and workplace safety compliance.
                </p>

              </div>

            </div>

          </div>

        </section>
        <section className="pb-4">

          <div className="container">

            <div
              className="overflow-hidden rounded-4 shadow-lg"
            >

              <img
                src="assets/img/IndustrialAR2.png"
                alt="Industrial AR Capabilities"
                className="img-fluid w-100"
                style={{
                  height: "420px",
                  objectFit: "cover"
                }}
              />

            </div>

          </div>

        </section>
        <section className="py-5 bg-light">
          <div className="container">

            <h2 className="text-center fw-bold mb-5">
              Industrial AR Core Capabilities
            </h2>

            <div className="row g-4">

              <div className="col-lg-4">
                <div className="ar-capability-card">
                  <h4>Real-Time Equipment Data Overlays</h4>
                  <p style={{ color: "black" }}>
                    Access operating parameters, maintenance history,
                    diagnostics and performance metrics directly
                    within the technician's field of view.
                  </p>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="ar-capability-card">
                  <h4>Predictive Maintenance Alerts</h4>
                  <p style={{ color: "black" }}>
                    Detect cooling anomalies and equipment degradation
                    before failures impact operations.
                  </p>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="ar-capability-card">
                  <h4>Cooling Optimization</h4>
                  <p style={{ color: "black" }}>
                    Identify airflow inefficiencies and thermal
                    hotspots to reduce cooling costs.
                  </p>
                </div>
              </div>

            </div>

          </div>
        </section>



        {/* PARTNER */}
        <section className="py-5">

          <div className="container">

            <div className="row align-items-center">

              <div
                className="col-lg-5 mb-4 mb-lg-0 wow fadeInLeft"
                data-wow-delay="0.2s"
              >

                <img
                  src="assets/img/partner.png"
                  alt="Data Center Operations"
                  className="img-fluid rounded-4 shadow"
                  style={{
                    width: "100%",
                    height: "300px",
                    objectFit: "cover",
                    borderRadius: 24
                  }}
                />

              </div>

              <div
                className="col-lg-7 wow fadeInRight"
                data-wow-delay="0.3s"
              >

                <span className="private-tag">
                  Partner with Celersoft
                </span>

                <h3
                  style={{ fontSize: 30 }}
                  className="private-title mt-2"
                >
                  Smart Data Center Operations
                </h3>

                <p
                  className="private-text"
                  style={{
                    color: "black",
                    fontSize: 18
                  }}
                >
                  Celersoft helps enterprises modernize data center
                  maintenance through advanced Industrial AR solutions,
                  intelligent monitoring platforms, and predictive
                  maintenance technologies. Our expertise enables
                  organizations to reduce cooling-related operational
                  costs, improve infrastructure uptime, and create
                  safer, more efficient maintenance workflows.
                </p>

              </div>

            </div>

          </div>

        </section>


      </div>
      {/* Footer Start */}
      <div className="container-fluid footer wow fadeIn" data-wow-delay="0.2s">
        <div className="container pt-4">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 col-xl-3">
              <p>
                <span style={{ fontSize: 20 }}>
                  <em>
                    <strong>USA</strong>
                  </em>
                </span>
              </p>
              <p>
                <i className="fas fa-map-marker me-1" />1500 S Dairy Ashford Rd
                <br />
                Ste 355 Houston
                <br />
                TX 77077
              </p>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="single_address">
                <p>
                  <em>
                    <span style={{ fontSize: 20 }}>
                      <strong>CANADA</strong>
                    </span>
                  </em>
                </p>
                <p>
                  <i className="fas fa-map-marker me-1" /> 998 Loft Court,
                  <br />
                  London, Ontario
                  <br />
                  N6G0J9
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="single_address">
                <p>
                  <span style={{ fontSize: 20 }}>
                    <em>
                      <strong>INDIA</strong>
                    </em>
                  </span>
                </p>
                <p>
                  <i className="fas fa-map-marker me-1" /> D. No. 38, 2nd Floor,
                  <br />
                  Arjun Plaza, SP Road,
                  <br />
                  Nizampet, Hyderabad,
                  <br />
                  Telangana - 500085
                </p>
              </div>
            </div>

            <div className="col-md-6 col-lg-6 col-xl-3">
              <div className="footer-item d-flex flex-column">
                <a href="mailto:info@celersoft.com">
                  <i className="fas fa-envelope me-2" /> info@celersoft.com
                </a>
                <a href="tel:+18322258898">
                  <i className="fas fa-phone me-2" /> (+1) 832-225-8898
                </a>
                <hr />
                <div className="d-flex align-items-center">
                  <a
                    className="btn btn-light btn-md-square me-2"
                    href="https://www.facebook.com/celersoft"
                  >
                    <i className="fab fa-facebook-f" />
                  </a>
                  <a
                    className="btn btn-light btn-md-square me-0"
                    href="https://www.linkedin.com/company/celersoft/"
                  >
                    <i className="fab fa-linkedin-in" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid copyright py-3">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-md-6 text-center text-md-start mb-md-0">
              <span className="text-body">
                <i className="fas fa-copyright text-light me-1" />
                2024 Celersoft. All rights reserved.
              </span>
            </div>
            <div className="col-md-6 text-center text-md-end text-body">
              {/* <a
                className="border-bottom text-primary"
                href="https://htmlcodex.com"
              >
                HTML Codex
              </a>{" "}
              Distributed By{" "}
              <a
                className="border-bottom text-primary"
                href="https://themewagon.com"
              >
                ThemeWagon
              </a> */}
            </div>
          </div>
        </div>
      </div>

      <button
        className="btn btn-primary btn-lg-square back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <i className="fa fa-arrow-up" />
      </button>
      {/* Footer End */}
    </>
  );
}

export default IndustrialAR;